// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/batamp/" + chunkId + "." + {"109":"40846dfa1a388cf7a6e0","234":"b938db6a4f504edbf6ff","239":"27af907f0b9728c6948a","508":"a3479a240aa99a4bfebb","765":"6b2959163df31bd81b1e","837":"b1457a94e80956a55e84"}[chunkId] + ".js";
};